import { LogLevel } from '@shared/logger';
import { z } from 'zod';

/**
 * Parse and validate the configuration.
 *
 * Use `z.string()` to parse string values.
 * Use `z.coerce.number()` to parse number values.
 * Use `z.coerce.boolean()` to parse boolean values.
 */
export default z.object({
  mode: z.enum(['development', 'production', 'staging', 'uat']),
  logLevel: z.nativeEnum(LogLevel).default(LogLevel.INFO),
  showConsole: z.boolean().default(false),
  termsAndConditions: z.object({
    url: z.object({
      th: z.string(),
      en: z.string(),
    }),
  }),
  graphql: z.object({
    apiUrl: z.string().min(1).url(),
  }),
});
